/*
**  rui-common-styles-buttons.js
**
**  Styling for buttons, for use in LitElement-based apps
*/
import { css } from 'lit-element';
export const ruiCommonStylesButtons = css `

:host {
    display: inline-block;
}

.rui-btn {
    background-image: none;
    border-radius: var(--btn-border-radius, 1px);
    border-style: var(--btn-border-style, solid);
    border-width: var(--btn-border-width, 1px);
    box-shadow: var(--btn-box-shadow, none);
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: var(--font-family, "Segoe UI", "Open Sans", "Helvetica Neue", Arial, sans-serif);
    font-size: var(--btn-font-size-md, 14px);
    font-weight: var(--btn-font-weight, 400);
    line-height: var(--btn-line-height-md, 1.42857143);
    margin-bottom: 0;
    min-height: 32px;
    min-width: 38px;
    padding: var(--btn-padding-md, 5px 11px);
	position: relative;
    text-align: center;
    text-decoration: none;
    touch-action: manipulation;
    transition: background 0.25s;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 100%;
    -webkit-font-smoothing: antialiased;
}

.rui-btn.rui-split-button-caret-btn {
    min-width: auto;
}

.rui-btn:disabled {
    cursor: not-allowed;
    filter: none;
}

.rui-btn-sm {
    font-size: var(--btn-font-size-sm, 12px);
    line-height: var(--btn-line-height-sm, 1.5);
    min-height: 28px;
    min-width: 34px;
    padding: var(--btn-padding-sm, 4px 9px);
}

.rui-btn-sm .rui-btn-icon {
    position: absolute;
    left: 9px;
    top: 6px;
}

.rui-btn-primary {
    background-color: var(--btn-primary-bg, #3878ab);
    border-color: var(--btn-primary-bg, #3878ab);
    color: var(--btn-primary-fg, #fff);
}

.rui-btn-primary:hover {
    background-color: var(--btn-primary-bg-hover, #2e628c);
    border-color: var(--btn-primary-bg-hover, #2e628c);
    color: var(--btn-primary-fg-hover, #fff);
}

.rui-btn-primary:focus {
    background-color: var(--btn-primary-bg-hover, #2e628c);
    border-color: var(--btn-primary-bg-hover, #2e628c);
    color: var(--btn-primary-fg-hover, #fff);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-primary-border, #3878ab);
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-primary:active {
    background-color: var(--btn-primary-bg-active, #1f425e);
    border-color: var(--btn-primary-bg-hover, #2e628c);
    color: var(--btn-primary-fg-hover, #fff);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-primary-border, #3878ab);
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-primary:disabled {
    background-color: var(--btn-primary-bg-disabled, #e9e9e9);
    border-color: var(--btn-primary-border-disabled, #cdcdcd);
    color: var(--btn-primary-fg-disabled, #999);
    outline: none;
}

.rui-btn-secondary {
    background-color: var(--btn-secondary-bg, #fff);
    border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    color: var(--btn-secondary-fg, #3878ab);
}

.rui-btn-secondary:hover {
    background-color: var(--btn-secondary-bg-hover, #f2f2f5);
    border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    color: var(--btn-secondary-fg-hover, #3878ab);
}

.rui-btn-secondary:focus {
    background-color: var(--btn-secondary-bg-hover, #f2f2f5);
    border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    color: var(--btn-secondary-fg-hover, #3878ab);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-secondary:active {
    background-color: var(--btn-secondary-bg-active, #d5d5df);
    border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    color: var(--btn-secondary-fg-hover, #3878ab);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-secondary:disabled {
    background-color: var(--btn-secondary-bg-disabled, #e9e9e9);
    border-color: var(--btn-secondary-border-disabled, #cdcdcd);
    color: var(--btn-secondary-fg-disabled, #999);
    outline: none;
}

.rui-btn-destructive {
    background-color: var(--btn-destructive-bg, #fff2f2);
    border-color: var(--btn-destructive-border, #e13329);
    color: var(--btn-destructive-fg, #e13329);
}

.rui-btn-destructive:hover {
    background-color: var(--btn-destructive-bg-hover, #f9e5e5);
    border-color: var(--btn-destructive-border, #e13329);
    color: var(--btn-destructive-fg-hover, #e13329);
}

.rui-btn-destructive:focus {
    background-color: var(--btn-destructive-bg-hover, #f9e5e5);
    border-color: var(--btn-destructive-border, #e13329);
    color: var(--btn-destructive-fg-hover, #e13329);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-destructive-border, #e13329);
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-destructive:active {
    background-color: var(--btn-destructive-bg-active, #f7d9d9);
    border-color: var(--btn-destructive-border, #e13329);
    color: var(--btn-destructive-fg-hover, #e13329);
    outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-destructive-border, #e13329);
    outline-offset: var(--outline-offset-btn, 0);
}

.rui-btn-destructive:disabled {
    background-color: var(--btn-destructive-bg-disabled, #e9e9e9);
    border-color: var(--btn-destructive-border-disabled, #cdcdcd);
    color: var(--btn-destructive-fg-disabled, #999);
    outline: none;
}

@media print {
    .rui-btn {
        background-color: transparent;
        border-color: #000000;
        color: #000000;
    }

    .rui-btn:disabled {
        opacity: 0.66;
        background-color: #cccccc;
        border-color: #666666;
        color: #666666;
    }
}
`;
